import { useMutation } from '@tanstack/react-query';
import { RcFile } from 'antd/es/upload';

import { getSMPBackendAPIAdmin } from '@/proxy';

function uploadResourceDocument(resourceId: string, file: RcFile, fileName: string) {
  if (!file) {
    return Promise.resolve();
  }
  return getSMPBackendAPIAdmin().resourceDocumentsControllerCreateV1(resourceId, {
    fileName: fileName,
    file: file,
  });
}

export function useUploadResourceDocument(resourceId: string) {
  return useMutation({
    mutationFn: ({ file, fileName }: { file: RcFile; fileName: string }) =>
      uploadResourceDocument(resourceId, file, fileName),
  });
}
